var map = {
	"./sphere01-graph-black.png": "./src/assets/pngs/spiky-ball/sphere01-graph-black.png",
	"./sphere01-graph.png": "./src/assets/pngs/spiky-ball/sphere01-graph.png",
	"./sphere02-graph-black.png": "./src/assets/pngs/spiky-ball/sphere02-graph-black.png",
	"./sphere02-graph.png": "./src/assets/pngs/spiky-ball/sphere02-graph.png",
	"./sphere03-graph-black.png": "./src/assets/pngs/spiky-ball/sphere03-graph-black.png",
	"./sphere03-graph.png": "./src/assets/pngs/spiky-ball/sphere03-graph.png",
	"./sphere04-graph-black.png": "./src/assets/pngs/spiky-ball/sphere04-graph-black.png",
	"./sphere04-graph.png": "./src/assets/pngs/spiky-ball/sphere04-graph.png",
	"./sphere05-graph-black.png": "./src/assets/pngs/spiky-ball/sphere05-graph-black.png",
	"./sphere05-graph.png": "./src/assets/pngs/spiky-ball/sphere05-graph.png",
	"./sphere06-graph-black.png": "./src/assets/pngs/spiky-ball/sphere06-graph-black.png",
	"./sphere06-graph.png": "./src/assets/pngs/spiky-ball/sphere06-graph.png",
	"./sphere07-graph-black.png": "./src/assets/pngs/spiky-ball/sphere07-graph-black.png",
	"./sphere07-graph.png": "./src/assets/pngs/spiky-ball/sphere07-graph.png",
	"./sphere08-graph-black.png": "./src/assets/pngs/spiky-ball/sphere08-graph-black.png",
	"./sphere08-graph.png": "./src/assets/pngs/spiky-ball/sphere08-graph.png",
	"./sphere09-graph-black.png": "./src/assets/pngs/spiky-ball/sphere09-graph-black.png",
	"./sphere09-graph.png": "./src/assets/pngs/spiky-ball/sphere09-graph.png",
	"./sphere10-graph-black.png": "./src/assets/pngs/spiky-ball/sphere10-graph-black.png",
	"./sphere10-graph.png": "./src/assets/pngs/spiky-ball/sphere10-graph.png",
	"./sphere11-graph-black.png": "./src/assets/pngs/spiky-ball/sphere11-graph-black.png",
	"./sphere11-graph.png": "./src/assets/pngs/spiky-ball/sphere11-graph.png",
	"./sphere12-graph-black.png": "./src/assets/pngs/spiky-ball/sphere12-graph-black.png",
	"./sphere12-graph.png": "./src/assets/pngs/spiky-ball/sphere12-graph.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/pngs/spiky-ball sync recursive ^\\.\\/.*$";